import { createConnector } from 'react-instantsearch-core';

export default createConnector({
    displayName: 'withInCategorySearch',

    getProvidedProps() {},

    refine(props, searchState, inCategorySearch) {
        const newSearchState = { ...searchState };
        newSearchState.manomano.inCategorySearch = inCategorySearch;
        return newSearchState;
    },
});
